// Data
export const SET_DATA = "SET_DATA";
export const SET_DATA_MULTI = "SET_DATA_MULTI";
export const ADD_DATA = "ADD_DATA";
export const ADD_DATA_MULTI = "ADD_DATA_MULTI";
export const RESET_DATA_KEY = "RESET_DATA_KEY";
export const REMOVE_DATA_KEY = "REMOVE_DATA_KEY";
export const REMOVE_DATA_ARRAY_ITEM = "REMOVE_DATA_ARRAY_ITEM";

// Authentication
export const SET_AUTHENTICATION = "SET_AUTHENTICATION";
export const RESET_AUTHENTICATION = "RESET_AUTHENTICATION";

// DESIGN
export const SET_DESIGN = "SET_DESIGN";
export const RESET_DESIGN = "RESET_DESIGN";
export const RESET_DESIGN_ITEM = "RESET_DESIGN_ITEM";

// CART
export const SET_CART = "SET_CART";
export const ADD_CART = 'ADD_CART';
export const UPDATE_CART = 'UPDATE_CART';
export const REMOVE_CART = 'REMOVE_CART';
export const RESET_CART = "RESET_CART";
export const RESET_CART_TIMESLOTS = "RESET_CART_TIMESLOTS";

// Management
export const SET_MANAGEMENT = "SET_MANAGEMENT";
export const SET_MANAGEMENT_MULTI = "SET_MANAGEMENT_MULTI";
export const RESET_MANAGEMENT = "RESET_MANAGEMENT";

// Other
export const RESET_DATA = "RESET_DATA";
